// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CategoryPagination{display:flex;justify-content:center;padding-top:2rem;max-width:400px;margin:auto}@media (max-width: 767px){.CategoryPagination{padding-bottom:0;display:none}}.CategoryPagination-ListItem{line-height:1.8;margin:0 5px 0;padding:0}.CategoryPagination-ListItem::before{content:''}@media (max-width: 767px){.CategoryPagination-ListItem:first-child{padding-left:0}}.CategoryPagination-ListItem:last-child{margin-bottom:0}\n", ""]);
// Exports
module.exports = exports;
